<app-header></app-header>
<section class="notd__grid wrapper--centered wrapper--organized user-profile">
  <div class="user-profile__column--left">
    <div class="user-profile__wrapper" *ngIf="userProfile">
      <div
        *ngIf="userProfile.profileImageUrl"
        class="user-profile__avatar">
        <img-lazy-loading
          class="user-profile__avatar__img"
          *ngIf="userProfile && userProfile.profileImageUrl"
          [mainThumb]="userProfile.profileImageUrl"
          [thumbs]="userProfile.profileImgThbs"></img-lazy-loading>
      </div>
      <h2
        *ngIf="userProfile.displayName || userProfile.userName || userProfile.userNameDisp" 
        class="user-profile__name">
          {{userProfile.displayName || userProfile.userName || userProfile.userNameDisp}}
      </h2>
      <div
        *ngIf="userProfile.bio" 
        class="user-profile__bio">
        {{userProfile.bio}}
      </div>
      <span
        *ngIf="userProfile.address"
        class="user-profile__location">
        <span
          class="user-profile__location__region"
          *ngIf="userProfile.address.region">{{userProfile.address.region}}</span>
        <span
          class="user-profile__location__conutry"
          *ngIf="userProfile.address.countryName">{{userProfile.address.countryName}}</span>
      </span>
      <span
        *ngIf="userProfile.created"
        class="user-profile__join-date">Joined: {{userProfile.created | date: 'MMM dd, yyyy'}}</span>
      <ul class="user-profile__sections">
        <li *ngFor="let c of categories">
          <a
            [routerLink]="['/user', this.userIdent, 'profile', c.toLowerCase()]"
            [ngClass]="{'selected': selectedCategory === c.toLowerCase()}">{{c}}</a>
        </li>
      </ul>
      <div class="user-profile__share">
        <share-button
        [shareContent]="{title: 'This is ' + userProfile.displayName || userProfile.userName || userProfile.userNameDisp + ' profile!', message: 'Check out this awesome ' + userProfile.displayName || userProfile.userName || userProfile.userNameDisp + ' profile!' }"
        [contentElRef]="shareImgContentElement"></share-button>
      </div>
    </div>
  </div>
  <div class="user-profile__column--right">
    <section
      *ngIf="selectedCategory === 'notes'"
      class="user-profile__section section--notes">
        <h2 class="user-profile__section__title">Notes</h2>
        <div class="user-profile__section__content" *ngIf="!loadingContent">
          <note
            *ngFor="let note of userNotes | slice:0:notePageOffset"
            [note]="note"
            [view]="'list'"
            (noteDeletedEmitter)="noteDeletedEvent($event)"></note>
          <section
            class="user-profile__section__show-more"
            *ngIf="!loadingContent && userNotes && userNotes.length && userNotes.length > notePageOffset">
            <button
              (click)="showMoreNotes($event)"
              [ngClass]="{'loading--more': loadingMoreNotes}"
              class="notd__button--v2 border--green">{{ loadingMoreNotes ? 'Loading more...' : 'Show More' }}</button>
          </section>
        </div>
    </section>
    <section
      *ngIf="selectedCategory === 'streams'"
      class="user-profile__section section--streams">
        <h2 class="user-profile__section__title">Streams</h2>
        <div  class="user-profile__section__content" *ngIf="!loadingContent">
          <stream
            *ngFor="let stream of userStreams"
            [stream]="stream"></stream>
        </div>
    </section>
    <section
      *ngIf="selectedCategory === 'comments'"
      class="user-profile__section section--comments">
        <h2 class="user-profile__section__title">Comments</h2>
        <div  class="user-profile__section__content" *ngIf="!loadingContent">
          <div class="comment" *ngFor="let c of userComments">
            <h2 class="comment__note">
              <a class="comment__note__thumbnail"
                *ngIf="c.noteThumb"
                [routerLink]="c.shortURLPath ? ['/n', c.shortURLPath] : ['/notes', c.noteId, c.noteId || c.noteTitle]"
                [title]="'Read more in ' + c.noteTitle">
                <img [src]="c.noteThumb" />
              </a>
              <a
                [title]="'Read more in ' + c.noteTitle"
                [routerLink]="c.shortURLPath ? ['/n', c.shortURLPath] : ['/notes', c.noteId, c.noteId || c.noteTitle]" class="comment__note__title">
                {{c.noteTitle}}
              </a>
            </h2>
            <div class="comment__text">
              <p class="comment__text__label" *ngIf="userProfile.displayName || userProfile.userName || userProfile.userNameDisp">
                {{userProfile.displayName || userProfile.userName || userProfile.userNameDisp}} commented:
              </p>
              <span class="comment__text__dap icon--up">&#34;</span>{{c.comment}}<span class="comment__text__dap icon--down">&#34;</span>
            </div>
            <div class="comment__details">
              <span class="comment__details__date">{{c.created | date: 'MMM dd, yyyy'}}</span>
            </div>
          </div>
        </div>
    </section>
    <section
      *ngIf="selectedCategory === 'ratings'"
      class="user-profile__section section--ratings">
        <h2 class="user-profile__section__title">Ratings</h2>
        <div  class="user-profile__section__content" *ngIf="!loadingContent">
          <div class="rating" *ngFor="let r of userRatings">
            <h2 class="rating__note">
              <a class="rating__note__thumbnail"
                *ngIf="r.noteThumb"
                [routerLink]="r.shortURLPath ? ['/n', r.shortURLPath] : ['/notes', r.noteId, r.noteId || r.noteTitle]"
                [title]="'Read more in ' + r.noteTitle">
                <img [src]="r.noteThumb" />
              </a>
              <a
                [title]="'Read more in ' + r.noteTitle"
                [routerLink]="r.shortURLPath ? ['/n', r.shortURLPath] : ['/notes', r.noteId, r.noteId || r.noteTitle]" class="rating__note__title">
                {{r.noteTitle}}
              </a>
              <div class="rating__note__ratings">
                <span class="rating__text__rating">{{r.rating}}</span>
                <span class="rating__text__separator">/</span>
                <span class="rating__text__overall">5</span>
              </div>
            </h2>
            <div class="rating__details">
              <span class="rating__details__date">{{r.created | date: 'MMM dd, yyyy'}}</span>
            </div>
          </div>
        </div>
    </section>
    <div class="user-profile__section__loading" *ngIf="loadingContent">
      Loading content...
    </div>
  </div>
</section>

<section
  class="share-img-content"
  *ngIf="userProfile"
  #shareImgContent>
  <img class="share-img-content__logo" src="../../assets/logo-black.png" alt="Notd.io">
  <div class="share-img-content__content">
    <img
    *ngIf="userProfile.profileImageUrl"
    [src]="userProfile.profileImageUrl"/>
  </div>
  <h3
    *ngIf="userProfile.profileImageUrl"
    class="share-img-content__username">Check out {{userProfile.displayName || userProfile.userName || userProfile.userNameDisp}} profile!</h3>
  <section
    *ngIf="userProfile.bio" class="share-img-content__description">{{userProfile.bio}}</section>
</section>

<app-footer></app-footer>
